import React from 'react';
export function Guarantee() {
  return <section className="py-8 sm:py-12 px-4 bg-white" data-id="element-65">
      <div className="max-w-3xl mx-auto" data-id="element-66">
        <div className="bg-brand-sage/10 border-2 border-brand-sage p-8 rounded-xl text-center" data-id="element-67">
          <div className="text-5xl mb-4" data-id="element-68">🛡️</div>
          <h3 className="text-2xl sm:text-3xl font-serif font-bold text-brand-text-dark mb-4" data-id="element-69">
            30-Day Satisfaction Guarantee
          </h3>
          <div className="text-base text-brand-text-muted space-y-2 max-w-2xl mx-auto" data-id="element-70">
            <p data-id="element-71">Try The Thyroid Reset Cookbook™ for the next 30 days.</p>
            <p data-id="element-72">
              Explore the recipes. Use the meal planners. Enjoy the bonuses.
            </p>
            <p data-id="element-73">
              And if you feel it's not the right fit for you, simply contact us.
            </p>
            <p className="font-bold text-brand-forest" data-id="element-74">
              The risk is completely on us.
            </p>
          </div>
        </div>
      </div>
    </section>;
}